module.exports = __webpack_public_path__ + "static/media/truck-theme.3b1ea994.svg";